import {
  ContactUsSection,
  HeroSection,
  LearnMoreSection,
  RegistrationSection,
  TestimonialsSection,
} from "@/components/landing-page";
import { Show, isDev } from "solid-js/web";

export default function WorkshopPage() {
  return (
    <main class="relative w-full">
      <div class="flex min-h-[calc(100svh-var(--header-height))] flex-col">
        <HeroSection class="grow" />
        <TestimonialsSection id="testimonials" />
      </div>
      <Show when={!isDev}>
        <LearnMoreSection id="info" />
      </Show>
      <RegistrationSection id="tickets" />
      <ContactUsSection id="contact" />
    </main>
  );
}
